/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { filterInvalid, goQuery } from '@bluevision/tools';

export default function useFilterModel() {
  const [filters, setFilters] = useState<any>(null);

  const saveParams = (params: any) => {
    setFilters(params);
    goQuery(params);
  };

  const setParams = (params: any) => {
    const current = filterInvalid(params);
    if (current?.currentPage && current?.pageSize !== filters?.pageSize) {
      // 有参数变化时， 页码回到默认
      delete current.currentPage;
    }
    saveParams(current);
  };

  const clearParams = () => {
    // 清除筛选项，不做URL更新, 页面销毁时使用
    setFilters({});
  };

  const resetParams = (params?: any) => {
    // 重置筛选项，URL更新, 重置参数时使用
    saveParams(filterInvalid(params));
  };

  return {
    filters,
    setFilter: setParams,
    clearFilter: clearParams,
    resetFilter: resetParams,
  };
}
